import { Sparkles, Loader2 } from "lucide-react";
import { Switch } from "@/components/ui/switch";

export function AISearchBar({ query, setQuery, onSubmit, searching, sharing, onToggleShare }) {
  return (
    <div className="sticky top-[57px] z-30 px-4 md:px-8 py-4 flex items-center gap-3">
      <form onSubmit={onSubmit} className="flex-1 relative">
        <div className="glass rounded-full pl-4 pr-2 py-2 flex items-center gap-2 border border-white/10 focus-within:border-[#00E5FF] transition-all">
          <Sparkles size={16} className="text-[#00E5FF]" />
          <input
            data-testid="ai-search-input"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder='Ask AI: "find climbers open tonight"'
            className="flex-1 bg-transparent focus:outline-none text-sm placeholder:text-white/40"
          />
          <button
            data-testid="ai-search-submit"
            type="submit"
            disabled={searching}
            className="bg-[#00E5FF] text-black text-xs font-semibold px-3 py-1.5 rounded-full hover:glow-primary transition-all disabled:opacity-50"
          >
            {searching ? <Loader2 size={14} className="animate-spin" /> : "Scan"}
          </button>
        </div>
      </form>
      <div className="hidden sm:flex items-center gap-2 px-3 py-2 glass rounded-full border border-white/10">
        <span className="text-[10px] tracking-widest font-mono text-white/50">SHARE</span>
        <Switch data-testid="location-share-toggle" checked={sharing} onCheckedChange={onToggleShare} />
      </div>
    </div>
  );
}
